import React from "react";
import Slider from "./Slider";
import { motion } from "framer-motion";
import { Section, Container, Row, Col, Title, Subtitle, Paragraph, ImageContainer } from "./overviewStyle";

// Animation Variants
const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const slideInRight = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const CompanyOverview = () => {
  return (
    <Section>
      <Container className="container">
        <Row className="row align-items-center">
          <Col className="col-lg-6">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
              className="who-we-are__content"
            >
              <Title className="who-we-are__title">
                Company <span>Overview</span>
              </Title>
              <Subtitle className="mb-4">Accelerating Digital Transformation</Subtitle>
              <Paragraph className="who-we-are-paragraph">
                NexTech is a trusted leading PLM and Engineering solutions provider helping customers across the globe accelerate the
                digital transformation and establish a Teamcenter PLM platform as a backbone of the digital enterprise. We are
                specialized in providing Teamcenter PLM and CAD/CAM/CAE Solutions by understanding business needs as much as
                technology and helping clients improve their profitability and efficiency by providing high-value technology consulting,
                solutions, training, staffing, and project outsourcing. NexTech has extensive experience in Information Technology,
                Software development, and Engineering Design technologies with a proven global delivery model.
              </Paragraph>
            </motion.div>
          </Col>
          <Col className="col-lg-6">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={slideInRight}
              className="who-we-are__img"
            >
              <ImageContainer>
                <Slider />
              </ImageContainer>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </Section>
  );
};

export default CompanyOverview;
